import React from 'react';
import {
    Stack,
    Button,
    Grid,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { saveMicroExperienceForCustomer } from '../../../Services/Microexperiences';

export default function BundleCardDetailsView({ card, customer, experienceDate, onSaveCard, onClose, onBackClicked, cardType }) {
    const [activeMX, setActiveMX] = React.useState(card);
    const [activeDate, setActiveDate] = React.useState(experienceDate);  

    function setExperienceDate(date) {
        setActiveMX({ ...activeMX, experienceDate: moment(date).toISOString() });
        setActiveDate(date);
    }

    function setDeliveryType(deliveryType) { 
        setActiveMX({ ...activeMX, deliveryType }); 
    }
    
    function setInternalStatus(internalStatus) { 
        setActiveMX({ ...activeMX, internalStatus }); 
    }

    function setInternalNotes(internalNotes) { 
        setActiveMX({ ...activeMX, internalNotes }); 
    }

    function setCustomerFeedback(customerFeedback) { 
        setActiveMX({ ...activeMX, customerFeedback }); 
    }

    function backClicked() {
        onBackClicked();
    }

    function saveMicroExperience() {
       
        const data = {
            user_id : customer.profile.id,
            internal_status : activeMX.internalStatus,
            delivery_type : activeMX.deliveryType,
            display_name : activeMX.bundleName,
            effort_size : ' ',
            effort_value : ' ',
            cardVariation : ' ',
            scheduled_date : activeDate,
            aex_micro_content_id : activeMX.id,
            micro_content_cache : '{}',
            micro_content_variation_cache : '{}',
            customer_status : ' ',
            internal_note : activeMX.internalNotes,
            customer_feedback : activeMX.customerFeedback || ' ',
            mx_type : cardType,
            bundle_type : activeMX.bundleType,
        };

        saveMicroExperienceForCustomer(customer.profile.id, data)
        .then(response => {
            console.log('SUCCESS : ', response)
            onSaveCard(activeMX);
        })
        .catch(err => {
            console.log('ERROR : ', err);
            //setDoSubmit(false);
        })        
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Stack direction="column" sx={{ justifyContent: 'space-between', flex: 1 }}>
            <Stack direction="column">
                <Grid item xs={12}>
                    <Typography style={{ flex: '1', whiteSpace: 'no-wrap', fontSize: '20px' }}>
                        {activeMX.bundleName}
                    </Typography>                       
                </Grid>
                <Stack direction="row" sx={{  flex: 1 }} xs={12}>
                    <Grid item xs={2}>
                            <InputLabel id="mx-date-label">Date</InputLabel>
                            <DatePicker
                                fullWidth
                                labelId={'mx-date-label'}
                                value={activeDate}
                                onChange={(newValue) => setExperienceDate(newValue)}
                                renderInput={(params) => <TextField {...params} />}
                            />
                    </Grid>
                    <Grid item xs={2} sx={{marginLeft:'15px'}}>
                            <InputLabel id="mx-delivery-label">Delivery *</InputLabel>
                            <Select                                
                                sx={{width:'150px'}}
                                displayEmpty
                                labelId="mx-delivery-label"
                                value={activeMX.deliveryType || ''}
                                onChange={(e) => setDeliveryType(e.target.value)}
                            >
                                <MenuItem value="">-- SELECT --</MenuItem>
                                <MenuItem value="SMS">SMS</MenuItem>
                                <MenuItem value="Email">Email</MenuItem>
                                <MenuItem value="EEE">EEE</MenuItem>
                            </Select>
                    </Grid>
                    <Grid item xs={2} sx={{marginLeft:'15px'}}>
                        <InputLabel id="mx-status-label">Status *</InputLabel>
                        <Select                                
                            sx={{width:'150px'}}
                            displayEmpty
                            labelId="mx-status-label"
                            value={activeMX.internalStatus || ''}
                            onChange={(e) => setInternalStatus(e.target.value)}
                        >
                            <MenuItem value="">-- SELECT --</MenuItem>
                            <MenuItem value="PENDING">Pending</MenuItem>
                            <MenuItem value="ASSIGNED ">Assigned </MenuItem>
                            <MenuItem value="SENT">Sent</MenuItem>
                            <MenuItem value="COMPLETE">Complete</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={6} sx={{marginLeft:'20px', width: '450px',}}>
                        <InputLabel id="mx-notes-label">Notes *</InputLabel>
                        <TextField
                            size="medium"
                            fullWidth
                            labelId="mx-notes-label"
                            value={activeMX.internalNotes || ''}
                            onChange={(e) => setInternalNotes(e.target.value)}
                        />
                    </Grid>
                </Stack>     
                <Grid container item xs={10.8} >
                        <InputLabel id="mx-feedback-label">Feedback</InputLabel>
                        <TextField
                            size="medium"
                            fullWidth
                            labelId="mx-feedback-label"
                            value={activeMX.customerFeedback || ' '}
                            onChange={(e) => setCustomerFeedback(e.target.value)}
                        />
                </Grid>                        
            </Stack>
            <Stack direction="row" justifyContent="flex-end" spacing={8} m={4} justifySelf="flex-end">
                {!!onBackClicked && (
                    <Button variant="contained" color="secondary" onClick={backClicked}>
                        Back to list
                    </Button>
                )}
                <Button variant="contained" color="primary" onClick={saveMicroExperience} disabled={!activeMX.deliveryType || !activeMX.internalStatus || !activeMX.internalNotes}>
                    Save Bundle
                </Button>
            </Stack>
        </Stack>
        </LocalizationProvider>
    );
}
